import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {SettingsDevelopersApplicationFeaturesUrl} from '../../../../models/url/settingsUrlModel';
import {AppState} from '../../../../store/appState';
import {makeGetLocalApplication} from '../../../../store/data/localApplications/localApplicationsSelectors';
import {SettingsDevelopersHeaderFeaturesAction} from './settingsDevelopersHeaderFeaturesAction';

/*
 * Props.
 */

interface SettingsDevelopersHeaderFeaturesActionContainerProps {
  url: SettingsDevelopersApplicationFeaturesUrl;
}

/*
 * Selectors.
 */

function getApplicationId(_state: AppState, props: SettingsDevelopersHeaderFeaturesActionContainerProps) {
  return props.url.applicationId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersHeaderFeaturesActionContainerProps>()(() => ({
  application: makeGetLocalApplication(getApplicationId),
}));

export const SettingsDevelopersHeaderFeaturesActionContainer = connect(mapStateToProps)(
  SettingsDevelopersHeaderFeaturesAction,
);
